

import { getTypoCSS } from '../../bpl-tools/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { contentTypo, contentColor } = attributes;
	const mainEle = `#eebEmailEncode-${clientId}`;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS('', contentTypo)?.googleFontLink}
		${getTypoCSS(`${mainEle} .eebEmailEncode .content-${clientId} a`, contentTypo)?.styles}
		${getTypoCSS(`${mainEle} .eebEmailEncode .content-${clientId} span`, contentTypo)?.styles}

		${mainEle} .eebEmailEncode .content-${clientId} a, ${mainEle} .eebEmailEncode .content-${clientId} span{
			color: ${contentColor};
		}

		${mainEle} .eebEmailEncode .content-${clientId} a, ${mainEle} .eebEmailEncode .content-${clientId} span {
			direction: rtl;
    		unicode-bidi: bidi-override;
		}
		
		
	`}} />;
}
export default Style;